/* @flow */

import { Component } from 'react';
import type { Node } from 'react';

type $Props = {
  children: Node
};

type $State = {
  hasError: boolean
};

export default class ErrorBoundary extends Component<$Props, $State> {
  state = {
    hasError: false
  };

  componentDidCatch(error: Error & { suppressReactErrorLogging: boolean }) {
    /* Supposed to work, #FIXME #TODO */
    error.suppressReactErrorLogging = true;
    this.setState({ hasError: true });
  }

  render() {
    return !this.state.hasError ? this.props.children : null;
  }
}
